import { BAD_AGE_QUERY as SHARED_BAD_AGE_QUERY } from "@salestrak/widgets";
import type { FilterState } from "#app/lib/filters/types";

/**
 * Persisted advanced-filter builder states compiled at read time by
 * `resolveWidgetFilters`.
 */

/**
 * Age "bad" = At Risk / Off Track (the two alerting `AGE_STATUS` values from
 * `lib/age-status.ts`). Persisted as an advanced-filter builder state;
 * `resolveWidgetFilters` compiles it at read time to
 * `{ age: { status: { in: ["atRisk", "offTrack"] } } }`.
 *
 * The data is the shared copy the default boards embed (and the core API
 * persists on first-read seeding); this typed re-export is the app-side name.
 */
export const BAD_AGE_QUERY: FilterState = SHARED_BAD_AGE_QUERY;

/**
 * Age Off Track only — the most-stalled slice of `BAD_AGE_QUERY`.
 */
export const OFF_TRACK_QUERY: FilterState = {
  logic: "AND",
  blocks: [
    {
      logic: "AND",
      filters: [{ field: "age.status", operator: "in", value: ["offTrack"] }],
    },
  ],
};
